import { SafeArea } from '@capacitor-community/safe-area';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';

import App from './App.tsx';

import './index.css';
import 'react-toastify/dist/ReactToastify.min.css';

void SafeArea.enable({
  config: {
    customColorsForSystemBars: false,
  },
});

void defineCustomElements(window);

const rootElement = document.getElementById('root')!;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.Fragment>
    <App />
    <ToastContainer />
  </React.Fragment>
);
